import { Col, Row, Table } from "reactstrap";
import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import moment from "moment";
import { useDispatch } from "react-redux";

function OveruseByShipper(props) {
  // console.log(props);
  const dispatch = useDispatch();

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const renderSubColumn = () => {
    let shipper = props.shipper;
    return (
      <React.Fragment key={shipper.label}>
        <th
          style={{
            backgroundColor: "#466597", // 5868b785
            color: "#FEF6AA",
            textAlign: "center",
            fontSize: "1.5vh",
            fontWeight: "bold",
          }}
        >
          Booking
        </th>
        <th
          style={{
            backgroundColor: "#466597", // 5868b785
            color: "#FEF6AA",
            textAlign: "center",
            fontSize: "1.5vh",
            fontWeight: "bold",
          }}
        >
          Actual
        </th>
        <th
          style={{
            backgroundColor: "#466597", // 5868b785
            color: "#FEF6AA",
            textAlign: "center",
            fontSize: "1.5vh",
            fontWeight: "bold",
          }}
        >
          Overuse
        </th>
      </React.Fragment>
    );
  };

  return (
    <>
      {/* <h5 style={{fontSize:"1.8vh"}}>{props.shipper.label}</h5> */}
      <div className="table-responsive" style={{ position:"relative", overflowY: "auto", maxHeight: "64vh" }}>
        <Table className="table table-bordered table-striped mb-0 mt-1">
          <thead>
            <tr>
              <th
                rowSpan={2}
                style={{
                  backgroundColor: "#466597", //556ee678
                  color: "#FEF6AA",
                  textAlign: "center",
                  fontSize: "1.5vh",
                  fontWeight: "bold",
                }}
              >
                Area
              </th>
            </tr>
            <tr>{renderSubColumn()}</tr>
          </thead>
          <tbody
            style={{
              color: "#FFFFFF",
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {Object.keys(props.overuseDataEntry).map(item => {
              return (
                <tr key={item}>
                  <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                    {item}
                  </td>
                  {props.overuseDataEntry[item]
                    .sort((a, b) =>
                      a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG
                        ? 1
                        : b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG
                        ? -1
                        : 0
                    )
                    .map(value => {
                      return (
                        <React.Fragment key={value.PID}>
                          <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                            <p>{numberFormat(value.OVERUSE_BOOKING, 0)}</p>
                          </td>
                          <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                            <p>{numberFormat(value.OVERUSE_ACTUAL, 0)}</p>
                          </td>
                          <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                            <p
                              style={{
                                ...((value.OVERUSE).toFixed(0) > 0
                                  ? { color: "#FF4545" }
                                  : { color: "#FFFFFF" }),
                                fontWeight: "bold",
                                fontSize: "1.4vh",
                              }}
                            >
                              {numberFormat(value.OVERUSE, 0)}
                            </p>
                          </td>
                        </React.Fragment>
                      );
                    })}
                </tr>
              );
            })}
            <tr style={{ backgroundColor: "#556ee630" }}>
              <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                Entry Total
              </td>
              {props.total.entry
                .sort((a, b) =>
                  a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG
                    ? 1
                    : b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG
                    ? -1
                    : 0
                )
                .map((value, index) => {
                  return (
                    <React.Fragment key={index.toString()}>
                      <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                        <p>{numberFormat(value.OVERUSE_BOOKING, 0)}</p>
                      </td>
                      <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                        <p>{numberFormat(value.OVERUSE_ACTUAL, 0)}</p>
                      </td>
                      <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                        <p
                          style={{
                            ...((value.OVERUSE).toFixed(0) > 0
                              ? { color: "#FF4545" }
                              : { color: "#FFFFFF" }),
                            fontWeight: "bold",
                            fontSize: "1.4vh",
                          }}
                        >
                          {numberFormat(value.OVERUSE, 0)}
                        </p>
                      </td>
                    </React.Fragment>
                  );
                })}
            </tr>
            {Object.keys(props.overuseDataExit).map(item => {
              return (
                <tr key={item}>
                  <td style={{ fontSize: "1.4vh", color: "#FFFFFF"  }}>{item}</td>
                  {props.overuseDataExit[item]
                    .sort((a, b) =>
                      a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG
                        ? 1
                        : b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG
                        ? -1
                        : 0
                    )
                    .map(value => {
                      return (
                        <React.Fragment key={value.PID}>
                          <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                            <p>{numberFormat(value.OVERUSE_BOOKING, 0)}</p>
                          </td>
                          <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                            <p>{numberFormat(value.OVERUSE_ACTUAL, 0)}</p>
                          </td>
                          <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                            <p
                              style={{
                                ...((value.OVERUSE).toFixed(0) > 0
                                  ? { color: "#FF4545" }
                                  : { color: "#FFFFFF" }),
                                fontWeight: "bold",
                                fontSize: "1.4vh",
                              }}
                            >
                              {numberFormat(value.OVERUSE, 0)}
                            </p>
                          </td>
                        </React.Fragment>
                      );
                    })}
                </tr>
              );
            })}
            <tr style={{ backgroundColor: "#556ee630" }}>
              <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                Exit Total
              </td>
              {props.total.exit
                .sort((a, b) =>
                  a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG
                    ? 1
                    : b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG
                    ? -1
                    : 0
                )
                .map((value, index) => {
                  return (
                    <React.Fragment key={index.toString()}>
                      <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                        <p>{numberFormat(value.OVERUSE_BOOKING, 0)}</p>
                      </td>
                      <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                        <p>{numberFormat(value.OVERUSE_ACTUAL, 0)}</p>
                      </td>
                      <td style={{ fontSize: "1.4vh", color: "#FFFFFF" }}>
                        <p
                          style={{
                            ...((value.OVERUSE).toFixed(0) > 0
                              ? { color: "#FF4545" }
                              : { color: "#FFFFFF" }),
                            fontWeight: "bold",
                            fontSize: "1.4vh",
                          }}
                        >
                          {numberFormat(value.OVERUSE, 0)}
                        </p>
                      </td>
                    </React.Fragment>
                  );
                })}
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
}

OveruseByShipper.propTypes = {
  t: PropTypes.any,
  shipper: PropTypes.any,
  overuseDataEntry: PropTypes.any,
  overuseDataExit: PropTypes.any,
  total: PropTypes.any,
};

export default OveruseByShipper;
